import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form, BooksAutocomplete } from "@shared/components";

export function BookAuthorForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("book_contributor_admin.fields.name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name_inverted"
          label={translate("book_contributor_admin.fields.name_inverted")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <BooksAutocomplete
          name="book"
          label={translate("v1/audiobook_admin.fields.book")}
          required
        />
      </Grid>
    </Grid>
  )
}
